// src/components/AwardsSync.tsx
'use client';

import * as React from "react";
import { GallerySync } from "@/components/GallerySync";
import { useAwardsSync } from "@/hooks/useAwardsAPI"; // make sure path matches

export function AwardsSync({
  className = "",
}: {
  className?: string;
}) {
  const { syncAwards, isLoading } = useAwardsSync();

  // Optional: read last sync time from localStorage
  const [lastSyncTime, setLastSyncTime] = React.useState<string | undefined>(() =>
    localStorage.getItem('awards:lastSync') || undefined
  );

  const handleSync = async () => {
    await syncAwards();
    // Update last sync timestamp after successful sync
    const stamp = localStorage.getItem('awards:lastSync');
    setLastSyncTime(stamp || undefined);
  };

  return (
    <GallerySync
      label="Awards Sync"
      onSync={handleSync}
      isLoading={isLoading}
      lastSyncTime={lastSyncTime}
      className={className}
    />
  );
}
